import { render } from "./AppContact.vue?vue&type=template&id=f5ea70d2&scoped=true"
import script from "./AppContact.vue?vue&type=script&lang=js"
export * from "./AppContact.vue?vue&type=script&lang=js"

import "./AppContact.vue?vue&type=style&index=0&id=f5ea70d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5ea70d2"]])

export default __exports__